import { render } from "./GekaufteZutatenAnzeigenView.vue?vue&type=template&id=dcc70064&scoped=true"
import script from "./GekaufteZutatenAnzeigenView.vue?vue&type=script&lang=js"
export * from "./GekaufteZutatenAnzeigenView.vue?vue&type=script&lang=js"

import "./GekaufteZutatenAnzeigenView.vue?vue&type=style&index=0&id=dcc70064&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc70064"]])

export default __exports__